export function consultationDateLabel(value: string, locale: "hr" | "en") {
  return new Intl.DateTimeFormat(locale === "hr" ? "hr-HR" : "en-GB", {
    day: "numeric",
    month: "long",
    timeZone: "Europe/Zagreb",
    weekday: "long",
    year: "numeric",
  }).format(new Date(`${value}T12:00:00Z`))
}
